import React, { useState } from 'react';
import CustomPhoneInput from './CustomPhoneInput';
import loginImage from '../../assets/hms-login-image.png';
import './Loginmodal.css';

const setCookie = (name, value) => {
  const date = new Date();
  date.setTime(date.getTime() + (30 * 24 * 60 * 60 * 1000));
  const expires = `expires=${date.toUTCString()}`;
  const rootDomain = window.location.hostname.split('.').slice(-2).join('.');
  const domain = rootDomain.includes('localhost') ? '' : `;domain=.${rootDomain}`; const isSecure = window.location.protocol === 'https:' ? ';Secure' : '';
  document.cookie = `${name}=${value};${expires};path=/;${domain};SameSite=Lax${isSecure}`;
};

const runtimeApi = (window._env_ && window._env_.REACT_APP_API_URL) || null;
const runtimeDashboardUrl = (window._env_ && window._env_.REACT_APP_DASHBOARD_URL) || null;
const RAW_API_BASE = runtimeApi || process.env.REACT_APP_API_URL || `${window.location.protocol}//${window.location.hostname}${window.location.port ? ':' + window.location.port : ''}`;
const API_BASE = RAW_API_BASE.replace(/\/+$/, '').replace(/\/api$/, '');
const DASHBOARD_BASE = runtimeDashboardUrl || process.env.REACT_APP_DASHBOARD_URL || 'https://app.tecnvi-ai.com';
const LoginModal = ({ isOpen, onClose }) => {
  const [authType, setAuthType] = useState('email');
  const [formData, setFormData] = useState({ email: '', phone: '', password: '', rememberMe: false });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [availableRoles, setAvailableRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState('');
  const [showRoleSelector, setShowRoleSelector] = useState(false);
  const [roleModalError, setRoleModalError] = useState('');
  const [pendingLoginData, setPendingLoginData] = useState(null);
  
  // Forgot Password / Reset Password states
  const [view, setView] = useState('login'); // 'login' | 'forgot-password' | 'reset-password'
  const [resetOtp, setResetOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [resendTimer, setResendTimer] = useState(0);
  const [otpMethod, setOtpMethod] = useState('whatsapp');
  const [isIndianNumber, setIsIndianNumber] = useState(true);
  const [otpMethodSelected, setOtpMethodSelected] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
    if (name === 'phone') setOtpMethodSelected(false);
  };

  const validateForm = () => {
    const newErrors = {};
    if (authType === 'email') {
      if (!formData.email) newErrors.email = 'Email is required';
      else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Please enter a valid email address';
    } else {
      if (!formData.phone || formData.phone.length <= 1) {
        newErrors.phone = 'Phone number is required';
      } else if (isIndianNumber && formData.phone.length !== 13) {
        newErrors.phone = 'Indian phone numbers must be exactly 10 digits';
      }
    }
    if (!formData.password) newErrors.password = 'Password is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const normalizeRoles = (data) => {
    const roles = data?.user?.roles || data?.roles || data?.user?.roleList || [];
    if (Array.isArray(roles) && roles.length > 0) {
      return roles
        .map((item) => {
          if (typeof item === 'string') return item;
          return item?.name || item?.role || item?.label || null;
        })
        .filter(Boolean);
    }
    // Fallback: singular role string on user object
    const singleRole = data?.user?.role;
    if (singleRole && typeof singleRole === 'string') return [singleRole];
    return [];
  };

  const getRedirectPath = (user, role) => {
    // TODO: confirm this matches your actual data — check the
    // "=== BU LOGIN FULL RESPONSE ===" console log for the real field/value
    const orgType = (user?.orgType || user?.accountType || user?.tenantType || '').toLowerCase();
    const roleLower = (role || '').toLowerCase();
    const isHeadquarters =
      orgType === 'headquarters' ||
      orgType === 'hq' ||
      roleLower.includes('headquarter') ||
      roleLower === 'hq' ||
      roleLower === 'admin';

    return isHeadquarters ? '/admin-users/overview' : '/dashboard/overview';
  };

  const buildDashboardUrl = (tokens, user, role) => {
    const params = new URLSearchParams();
    params.set('hms_at', tokens.accessToken);
    params.set('hms_rt', tokens.refreshToken);
    params.set('hms_user', JSON.stringify(user));
    if (role) params.set('hms_role', role);
    params.set('hms_ref', window.location.origin);
    // Hash (#) keeps tokens out of server logs and browser history.
    // The inline script in index.html moves them to sessionStorage before React loads.
    const path = getRedirectPath(user, role);
    // If the user is coming from the marketing site (healthmarshal-ai.com),
    // always redirect to the hosted dashboard at app.tecnvi-ai.com so logout
    // can return the user back to the originating site.
    // Always redirect to the hosted dashboard to ensure users land
    // on the production admin app rather than remaining on the marketing site.
    const targetBase = 'https://app.tecnvi-ai.com';
    return `${targetBase.replace(/\/\/+$/,'')}${path}#${params.toString()}`;
  };

  const completeLogin = (tokens, user, role) => {
    setCookie('voicebot_access_token', tokens.accessToken);
    setCookie('voicebot_refresh_token', tokens.refreshToken);
    setCookie('voicebot_user', encodeURIComponent(JSON.stringify(user)));
    localStorage.setItem('voicebot_access_token', tokens.accessToken);
    localStorage.setItem('voicebot_refresh_token', tokens.refreshToken);
    localStorage.setItem('voicebot_user', JSON.stringify(user));
    localStorage.setItem('hms_referrer', window.location.origin);
    // Also set a cookie so the dashboard (or logout flow) can read the
    // originating site and redirect back on logout.
    setCookie('hms_referrer', window.location.origin);
    window.location.href = buildDashboardUrl(tokens, user, role);
  };

  const openRoleSelector = (tokens, user, roles) => {
    setPendingLoginData({ tokens, user });
    setAvailableRoles(roles);
    setSelectedRole('');
    setRoleModalError('');
    setShowRoleSelector(true);
  };

  const handleConfirmRoleSelection = () => {
    if (!selectedRole) {
      setRoleModalError('Please select a role to continue.');
      return;
    }
    if (!pendingLoginData) {
      setRoleModalError('Unable to continue. Please login again.');
      return;
    }
    const { tokens, user } = pendingLoginData;
    completeLogin(tokens, user, selectedRole);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setIsLoading(true);
    setErrors({});
    try {
      const loginIdentifier = authType === 'email' ? formData.email : formData.phone;
      // BU Login: checks the 'clients' table via /api/auth/login
      const response = await fetch(`${API_BASE}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: loginIdentifier,
          identifier: loginIdentifier,
          authType,
          ...(authType === 'phone' ? { phone: loginIdentifier } : {}),
          password: formData.password
        })
      });
      const data = await response.json();
      console.log('=== BU LOGIN FULL RESPONSE ===', JSON.stringify(data, null, 2));
      console.log('=== ROLES NORMALIZED ===', normalizeRoles(data));
      console.log('=== data.user.roles ===', data?.user?.roles);
      console.log('=== data.roles ===', data?.roles);
      if (data.success) {
        const { user, tokens } = data;
        const roles = normalizeRoles(data);
        console.log('=== ROLES LENGTH ===', roles.length);
        completeLogin(tokens, user, roles[0] || '');
      } else {
        // Show specific error messages based on error code
        const code = data.code;
        let errorMsg = 'Invalid credentials. Please try again.';
        if (code === 'EMAIL_NOT_FOUND' || code === 'PHONE_NOT_FOUND') {
          errorMsg = 'Account not found. Please sign up first to create an account.';
        } else if (code === 'INVALID_PASSWORD') {
          errorMsg = 'Incorrect password. Please try again.';
        } else if (code === 'ACCOUNT_NOT_ACTIVATED') {
          errorMsg = 'Account not activated. Please verify your email first.';
        } else if (code === 'ACCOUNT_LOCKED') {
          errorMsg = 'Account temporarily locked due to multiple failed attempts. Please try again later.';
        } else if (code === 'EMAIL_NOT_VERIFIED') {
          errorMsg = 'Email not verified. Please check your inbox and verify your email.';
        } else if (code === 'PHONE_NOT_VERIFIED') {
          errorMsg = 'Phone number not verified. Please verify your phone first.';
        } else if (data.error) {
          errorMsg = data.error;
        }
        setErrors({ general: errorMsg });
      }
    } catch (err) {
      setErrors({ general: 'Connection failed. Please try again.' });
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    let interval;
    if (view === 'reset-password' && resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [view, resendTimer]);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    if (authType === 'email' && !formData.email) {
      return setErrors({ email: 'Email is required' });
    }
    if (authType === 'phone') {
      if (!formData.phone || formData.phone.length <= 1) {
        return setErrors({ phone: 'Phone number is required' });
      }
      if (isIndianNumber && formData.phone.length !== 13) {
        return setErrors({ phone: 'Indian phone numbers must be exactly 10 digits' });
      }
      if (isIndianNumber && !otpMethodSelected) {
        return setErrors({ general: 'Please select a method to receive the OTP (WhatsApp or SMS).' });
      }
    }

    setIsLoading(true);
    setErrors({});
    try {
      const identifier = authType === 'email' ? formData.email : formData.phone;
      const response = await fetch(`${API_BASE}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          identifier,
          authType,
          email: authType === 'email' ? formData.email : undefined,
          phone: authType === 'phone' ? formData.phone : undefined,
          method: authType === 'phone' ? otpMethod : undefined
        })
      });
      const data = await response.json();
      if (data.success) {
        setView('reset-password');
        setResendTimer(45);
      } else {
        setErrors({ general: data.error || 'Failed to send password reset code.' });
      }
    } catch (err) {
      setErrors({ general: 'Connection failed. Please try again.' });
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendOtp = async () => {
    if (resendTimer > 0 || isLoading) return;
    setIsLoading(true);
    setErrors({});
    try {
      const identifier = authType === 'email' ? formData.email : formData.phone;
      const response = await fetch(`${API_BASE}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          identifier,
          authType,
          email: authType === 'email' ? formData.email : undefined,
          phone: authType === 'phone' ? formData.phone : undefined,
          method: authType === 'phone' ? otpMethod : undefined
        })
      });
      const data = await response.json();
      if (data.success) {
        setResendTimer(45);
        setResetOtp('');
      } else {
        setErrors({ general: data.error || 'Failed to resend password reset code.' });
      }
    } catch (err) {
      setErrors({ general: 'Connection failed. Please try again.' });
    } finally {
      setIsLoading(false);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    const newErrs = {};
    if (!resetOtp) newErrs.general = 'OTP is required';
    if (!newPassword || newPassword.length < 8) newErrs.newPassword = 'Password must be at least 8 characters';
    if (newPassword !== confirmNewPassword) newErrs.confirmNewPassword = 'Passwords do not match';
    if (Object.keys(newErrs).length > 0) {
      setErrors(newErrs);
      return;
    }

    setIsLoading(true);
    setErrors({});
    try {
      const identifier = authType === 'email' ? formData.email : formData.phone;
      const response = await fetch(`${API_BASE}/api/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          identifier,
          authType,
          email: authType === 'email' ? formData.email : undefined,
          phone: authType === 'phone' ? formData.phone : undefined,
          otp: resetOtp,
          newPassword
        })
      });
      const data = await response.json();
      if (data.success) {
        setView('login');
        setErrors({ success: 'Password reset successfully! You can now log in.' });
        setResetOtp('');
        setNewPassword('');
        setConfirmNewPassword('');
      } else {
        setErrors({ general: data.error || 'Failed to reset password.' });
      }
    } catch (err) {
      setErrors({ general: 'Connection failed. Please try again.' });
    } finally {
      setIsLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="login-modal-overlay" onClick={onClose}>
      <div className="login-modal-container auth-modal" onClick={e => e.stopPropagation()} style={{ '--modal-bg-image': `url(${loginImage})` }}>
        <button className="modal-close-btn" onClick={onClose} aria-label="Close">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
        <div className="modal-form-section">
          <div className="form-content">
            <div className="form-main">
              <h2 className="form-title" style={{ textAlign: 'center', marginBottom: '6px', fontSize: '22px' }}>
                {view === 'login' ? 'Welcome' : view === 'forgot-password' ? 'Reset Password' : 'Enter New Password'}
              </h2>
              <p className="form-subtitle" style={{ textAlign: 'center', marginBottom: '20px' }}>
                {view === 'login' ? 'Sign in to your account' : view === 'forgot-password' ? 'Enter your details to receive a code' : 'Set your new password'}
              </p>
              {errors.general && <div className="error-message" style={{ color: 'red', marginBottom: '12px', fontSize: '13px' }}>{errors.general}</div>}
              {errors.success && <div className="error-message" style={{ color: '#16a34a', background: '#f0fdf4', border: '1px solid #bbf7d0', padding: '10px', borderRadius: '6px', marginBottom: '12px', fontSize: '13px' }}>{errors.success}</div>}
              {view !== 'reset-password' && (
                <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', borderBottom: '2px solid #e0e0e0', paddingBottom: '10px' }}>
                  <button type="button" onClick={() => setAuthType('email')} style={{ flex: 1, padding: '10px', border: 'none', background: authType === 'email' ? '#7c3aed' : '#f3f4f6', color: authType === 'email' ? 'white' : '#6b7280', borderRadius: '6px', cursor: 'pointer', fontWeight: '500' }}>Email</button>
                  <button type="button" onClick={() => setAuthType('phone')} style={{ flex: 1, padding: '10px', border: 'none', background: authType === 'phone' ? '#7c3aed' : '#f3f4f6', color: authType === 'phone' ? 'white' : '#6b7280', borderRadius: '6px', cursor: 'pointer', fontWeight: '500' }}>Phone</button>
                </div>
              )}
              <form onSubmit={view === 'login' ? handleSubmit : view === 'forgot-password' ? handleForgotPassword : handleResetPassword} className="login-form">
                
                {/* IDENTIFIER FIELDS (For Login & Forgot Password) */}
                {view !== 'reset-password' && (
                  <>
                    {authType === 'email' ? (
                      <div className="modal-form-group">
                        <input type="email" id="email" name="email" placeholder=" " value={formData.email} onChange={handleInputChange} disabled={isLoading} />
                        <label htmlFor="email">Email</label>
                        {errors.email && <span className="field-error">{errors.email}</span>}
                      </div>
                    ) : (
                      <div className="phone-input-wrapper" style={{ marginBottom: '28px' }}>
                        <span className="phone-input-label">Phone Number</span>
                        <CustomPhoneInput
                          id="phone"
                          defaultCountry="in"
                          onChange={(raw, countryData) => {
                            setFormData(prev => ({ ...prev, phone: '+' + raw }));
                            if (errors.phone) setErrors(prev => ({ ...prev, phone: '' }));
                            setOtpMethodSelected(false);
                            if (countryData && countryData.dialCode === '91') setIsIndianNumber(true);
                            else { setIsIndianNumber(false); setOtpMethod('whatsapp'); }
                          }}
                          disabled={isLoading}
                        />
                        {errors.phone && <span className="field-error" style={{ fontSize: '12px', color: '#ef4444', marginTop: '4px', display: 'block' }}>{errors.phone}</span>}
                      </div>
                    )}
                  </>
                )}

                {/* LOGIN ONLY: PASSWORD FIELD */}
                {view === 'login' && (
                  <div className="modal-form-group">
                    <div className="password-input-wrapper">
                      <input type={showPassword ? 'text' : 'password'} id="password" name="password" placeholder=" " value={formData.password} onChange={handleInputChange} disabled={isLoading} />
                      <label htmlFor="password">Password</label>
                      <button type="button" className="password-toggle" onClick={() => setShowPassword(!showPassword)} disabled={isLoading}>
                        {showPassword ? (
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                        ) : (
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                        )}
                      </button>
                    </div>
                    {errors.password && <span className="field-error">{errors.password}</span>}
                  </div>
                )}

                {/* FORGOT PASSWORD ONLY: OTP METHOD SELECTOR FOR INDIAN NUMBERS */}
                {view === 'forgot-password' && authType === 'phone' && isIndianNumber && formData.phone && formData.phone.length > 2 && !otpMethodSelected && (
                  <div className="otp-method-selector" style={{ marginBottom: '20px', background: '#f9fafb', padding: '12px 16px', borderRadius: '12px', border: '1px solid #e5e7eb' }}>
                    <label style={{ display: 'block', marginBottom: '10px', fontSize: '14px', color: '#374151', fontWeight: '600' }}>Send reset code via:</label>
                    <div style={{ display: 'flex', gap: '20px' }}>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', color: '#4b5563' }}>
                        <input type="radio" name="otpMethod" value="whatsapp" checked={otpMethod === 'whatsapp'} onChange={() => { setOtpMethod('whatsapp'); setOtpMethodSelected(true); }} style={{ accentColor: '#7c3aed', width: '16px', height: '16px' }} /> 
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="#25D366"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/></svg> WhatsApp
                      </label>
                      <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', fontSize: '14px', color: '#4b5563' }}>
                        <input type="radio" name="otpMethod" value="sms" checked={otpMethod === 'sms'} onChange={() => { setOtpMethod('sms'); setOtpMethodSelected(true); }} style={{ accentColor: '#7c3aed', width: '16px', height: '16px' }} /> 
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg> SMS
                      </label>
                    </div>
                  </div>
                )}
                {view === 'forgot-password' && authType === 'phone' && isIndianNumber && formData.phone && formData.phone.length > 2 && otpMethodSelected && (
                  <div style={{ marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 14px', background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: '8px', fontSize: '13px', color: '#16a34a' }}>
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                    Code via <strong style={{ marginLeft: '3px' }}>{otpMethod === 'whatsapp' ? 'WhatsApp' : 'SMS'}</strong>
                    <button type="button" onClick={() => setOtpMethodSelected(false)} style={{ marginLeft: 'auto', background: 'none', border: 'none', color: '#16a34a', cursor: 'pointer', fontSize: '12px', textDecoration: 'underline', padding: 0 }}>Change</button>
                  </div>
                )}

                {/* RESET PASSWORD FIELDS */}
                {view === 'reset-password' && (
                  <>
                    <div className="modal-form-group">
                      <input type="text" id="resetOtp" value={resetOtp} onChange={(e) => { setResetOtp(e.target.value); if (errors.resetOtp) setErrors(prev => ({ ...prev, resetOtp: '' })); }} placeholder=" " disabled={isLoading} />
                      <label htmlFor="resetOtp">Reset Code (OTP)</label>
                    </div>
                    <div className="modal-form-group">
                      <div className="password-input-wrapper">
                        <input type={showPassword ? 'text' : 'password'} id="newPassword" value={newPassword} onChange={(e) => { setNewPassword(e.target.value); if (errors.newPassword) setErrors(prev => ({ ...prev, newPassword: '' })); }} placeholder=" " disabled={isLoading} />
                        <label htmlFor="newPassword">New Password</label>
                        <button type="button" className="password-toggle" onClick={() => setShowPassword(!showPassword)} disabled={isLoading}>
                          {showPassword ? (
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                          ) : (
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                          )}
                        </button>
                      </div>
                      {errors.newPassword && <span className="field-error">{errors.newPassword}</span>}
                    </div>
                    <div className="modal-form-group">
                      <div className="password-input-wrapper">
                        <input type="password" id="confirmNewPassword" value={confirmNewPassword} onChange={(e) => { setConfirmNewPassword(e.target.value); if (errors.confirmNewPassword) setErrors(prev => ({ ...prev, confirmNewPassword: '' })); }} placeholder=" " disabled={isLoading} />
                        <label htmlFor="confirmNewPassword">Confirm New Password</label>
                      </div>
                      {errors.confirmNewPassword && <span className="field-error">{errors.confirmNewPassword}</span>}
                    </div>
                  </>
                )}

                {/* FORM OPTIONS & SUBMIT BUTTON */}
                <div className="form-options" style={{ display: 'flex', justifyContent: view === 'login' ? 'space-between' : 'flex-end' }}>
                  {view === 'login' ? (
                    <>
                      <div className="form-check login-remember-me-container">
                        <input type="checkbox" id="rememberMe" name="rememberMe" className="auth-custom-checkbox" checked={formData.rememberMe} onChange={handleInputChange} />
                        <label htmlFor="rememberMe" className="login-remember-me-label">Remember me</label>
                      </div>
                      <button type="button" className="forgot-password-btn" onClick={() => { setView('forgot-password'); setErrors({}); }}>Forgot Password?</button>
                    </>
                  ) : view === 'forgot-password' ? (
                    <button type="button" className="forgot-password-btn" onClick={() => { setView('login'); setErrors({}); }}>Back to Login</button>
                  ) : null}
                </div>
                <button type="submit" className="submit-btn" disabled={isLoading}>
                  {isLoading ? 'Processing...' : view === 'login' ? 'Log In' : view === 'forgot-password' ? 'Send Reset Code' : 'Reset Password'}
                </button>

                {view === 'reset-password' && (
                  <>
                    <div style={{ textAlign: 'center', marginTop: '15px' }}>
                      <button type="button" onClick={handleResendOtp} disabled={resendTimer > 0 || isLoading} style={{ background: 'transparent', color: resendTimer > 0 ? '#9ca3af' : '#7c3aed', border: 'none', cursor: resendTimer > 0 ? 'not-allowed' : 'pointer', fontWeight: '500', fontSize: '14px', marginBottom: '10px' }}>
                        {resendTimer > 0 ? `Resend OTP in ${resendTimer}s` : 'Resend OTP'}
                      </button>
                    </div>
                    <div style={{ textAlign: 'center', marginTop: '5px' }}>
                      <button type="button" onClick={() => { setView('login'); setErrors({}); }} style={{ background: 'transparent', color: '#6b7280', border: 'none', cursor: 'pointer', textDecoration: 'underline', fontSize: '14px' }}>Back to Login</button>
                    </div>
                  </>
                )}
              </form>
            </div>
          </div>
        </div>
        <div className="modal-image-section">
          <img src={loginImage} alt="Login" className="modal-image" />
          <div className="image-overlay">
            <div className="decorative-shape top-left-shape"></div>
            <div className="decorative-shape bottom-right-shape"></div>
            <div className="overlay-content">
              <div className="overlay-card">
                <h3>Welcome Back, Your Way!</h3>
                <p>Continue your journey with personalized communication solutions & seamless experiences.</p>
              </div>
              <div className="bottom-overlay">
                <h3>Access Your Dashboard, Beyond Boundaries!</h3>
                <p>Resume your communication revolution today!</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showRoleSelector && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)', zIndex: 2000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
          <div style={{ width: '100%', maxWidth: '460px', background: '#ffffff', borderRadius: '20px', padding: '28px', boxShadow: '0 20px 60px rgba(0,0,0,0.22)', position: 'relative' }}>
            <h2 style={{ margin: '0 0 10px', fontSize: '22px' }}>Select a role to continue</h2>
            <p style={{ margin: '0 0 20px', color: '#555' }}>Choose one of the roles configured for your account.</p>
            <div style={{ display: 'grid', gap: '10px', marginBottom: '18px' }}>
              {availableRoles.map((role) => (
                <button
                  key={role}
                  type="button"
                  onClick={() => { setSelectedRole(role); setRoleModalError(''); }}
                  style={{
                    width: '100%',
                    padding: '14px 18px',
                    borderRadius: '12px',
                    border: selectedRole === role ? '2px solid #7c3aed' : '1px solid #d1d5db',
                    background: selectedRole === role ? '#f5f3ff' : '#ffffff',
                    color: '#111827',
                    textAlign: 'left',
                    cursor: 'pointer',
                    fontWeight: selectedRole === role ? 700 : 500,
                  }}
                >
                  {role}
                </button>
              ))}
            </div>
            {roleModalError && <div style={{ color: '#dc2626', marginBottom: '16px' }}>{roleModalError}</div>}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
              <button type="button" onClick={() => setShowRoleSelector(false)} style={{ padding: '12px 18px', borderRadius: '10px', border: '1px solid #d1d5db', background: '#ffffff', color: '#374151', cursor: 'pointer' }}>Cancel</button>
              <button type="button" onClick={handleConfirmRoleSelection} style={{ padding: '12px 18px', borderRadius: '10px', border: 'none', background: '#7c3aed', color: '#ffffff', cursor: 'pointer' }}>Continue</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginModal;
